import React from "react";
import { Carousel, Container } from "react-bootstrap";
import TitleBlock from "../TitleBlock";
const Testimonials = () => {
  const rot = ["fsda", "sdf", "as"];
  return (
    <div>
      <TitleBlock
        number="06"
        pretitle="Testimonials"
        title="What Our Guests Say"
        desc="Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptate
          aliquid nesciunt pariatur reprehenderit."
      />

      <Container>
        <Carousel>
          <Carousel.Item>
            <section className="testiWrapper">
              <span className="testiWrapper-icon"></span>
              <p className="testiWrapper-desc">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                beatae illum commodi blanditiis nostrum, nisi provident
                recusandae repellendus reiciendis. Cumque perspiciatis deserunt
                tempora maiores molestiae nam dolore ipsum. Recusandae, hic!
              </p>
              <div className="testiWrapper-name">
                {" "}
                <strong>Sarwan Thapa</strong>
              </div>
            </section>
          </Carousel.Item>
          <Carousel.Item>
            <section className="testiWrapper">
              <span className="testiWrapper-icon"></span>
              <p className="testiWrapper-desc">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                beatae illum commodi blanditiis nostrum, nisi provident
                recusandae repellendus reiciendis. Cumque perspiciatis deserunt
                tempora maiores molestiae nam dolore ipsum. Recusandae, hic!
              </p>
              <div className="testiWrapper-name">
                {" "}
                <strong>Sarwan Thapa</strong>
              </div>
            </section>
          </Carousel.Item>
          <Carousel.Item>
            <section className="testiWrapper">
              <span className="testiWrapper-icon"></span>
              <p className="testiWrapper-desc">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                beatae illum commodi blanditiis nostrum, nisi provident
                recusandae repellendus reiciendis. Cumque perspiciatis deserunt
                tempora maiores molestiae nam dolore ipsum. Recusandae, hic!
              </p>
              <div className="testiWrapper-name">
                {" "}
                <strong>Sarwan Thapa</strong>
              </div>
            </section>
          </Carousel.Item>
        </Carousel>
      </Container>
    </div>
  );
};

export default Testimonials;
